import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../lib/analytics";
import { captureAcquisitionParams } from "../../lib/acquisition";
import { isTokenBearingPath } from "../../lib/tokenBearingRoutes";

export default function PageViewTracker() {
  const location = useLocation();

  useLayoutEffect(() => {
    if (!location.hash) {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  useEffect(() => {
    // Pages whose URL carries a bearer token record no page view at all
    // (analytics.ts also refuses to start Mixpanel or gtag on them).
    if (isTokenBearingPath(location.pathname)) return;
    captureAcquisitionParams(location.search, location.pathname);
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
